import { useMutation } from '@tanstack/react-query';
import { fetchSendCode } from './service';
import { useAxiosInstance } from '@starsoft/common/hooks';
import { AxiosInstance } from 'axios';
import { SendCodeInputDto } from '@starsoft/common/dto';

/**
 * Custom hook to send verification codes via email
 *
 * This hook handles sending verification codes to user emails and managing the mutation state.
 * It uses React Query for data mutation and state management.
 *
 * @returns {Object} An object containing:
 *   - sendCode: Function to trigger sending verification code
 *   - isPending: Boolean indicating if sending is in progress
 *   - isSuccess: Boolean indicating if code was sent successfully
 */
export function useUserEmailSendCode() {
  const axiosInstance: AxiosInstance = useAxiosInstance();

  const { isPending, mutate, isSuccess } = useMutation({
    mutationFn: (data: SendCodeInputDto) => fetchSendCode(data, axiosInstance),
  });

  return {
    isPending,
    isSuccess,
    sendCode: mutate,
  };
}
